// extracted by mini-css-extract-plugin
export default {"tooltip":"SearchStatusLabel_tooltip__w2PGT"};